import React, { useState, useRef, useEffect } from 'react';
import styles from 'feature/common/landing/support/index.module.scss';
import className from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import security from 'images/landing/support_security.svg';
import useIntersect from 'utils/intersect-helper';

const cx = className.bind(styles);

const Support = () => {
  const { t } = useTranslation();
  const supportRef = useRef();
  const [imageshow, setImageShow] = useState(false);
  const [msgShow, setMsgShow] = useState(false);

  const [setElement] = useIntersect(() => {
    setTimeout(() => {
      setImageShow(true);
    }, 0);
    setTimeout(() => {
      setMsgShow(true);
    }, 300);
  });

  useEffect(() => {
    setElement([supportRef.current]);
  }, [setElement]);

  const imageClass = cx({
    show: imageshow,
  });

  const msgClass = cx({
    show: msgShow,
  });
  return (
    <section className={styles.support} ref={supportRef}>
      <div className={styles.canvas}>
        <h2>
          {t('landing.support.title')}
          <br />
          {t('landing.support.subtitle')}
        </h2>
        <img className={imageClass} src={security} alt="security" loading="lazy" />
        <h3 className={msgClass}>{t('landing.support.message')}</h3>
      </div>
    </section>
  );
};

export default Support;
